"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoWhiteComponent = exports.CancelRedComponent = exports.CheckGreenComponent = exports.ImageContainer = exports.Message = exports.ToastWrapper = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const building_blocks_ui_typography_1 = require("@acko-tech/building-blocks.ui.typography");
// import CancelRed from './assets/CancelRed';
// import SuccessGreen from './assets/CheckGreen';
// import InfoWhite from './assets/InfoWhite';
exports.ToastWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  background: ${(props) => props.colors.primary.n600};
  border-radius: ${(props) => props.theme.border.radius.large};
  padding: ${(props) => props.theme.spacing[3]};
  box-sizing: border-box;
  justify-content: space-between;
  position: fixed;
  z-index: 10;
  bottom: ${(props) => props.theme.spacing[8]};
  width: 100%;
  max-width: 480px;
  left: 50%;
  transform: translateX(-50%);
  @media screen and (max-width: ${(props) => props.theme.breakpoints.m}px) {
    bottom: ${(props) => props.theme.spacing[5]};
    width: ${`calc(100% - 40px)`};
  }
`;
exports.Message = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-size: ${(props) => props.theme.typography.fonts.size.P2};
  line-height: ${(props) => props.theme.typography.lineHeights.P2};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P2};
  color: ${(props) => props.colors.primary.n0};
  margin-left: ${(props) => props.theme.spacing[3]};
  text-wrap: wrap;
`;
exports.ImageContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  width: ${(props) => props.theme.spacing[6]};
  height: ${(props) => props.theme.spacing[6]};
  cursor: pointer;
`;
exports.CheckGreenComponent = building_blocks_ui_common_1.styled.img `
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
exports.CancelRedComponent = building_blocks_ui_common_1.styled.img `
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
exports.InfoWhiteComponent = building_blocks_ui_common_1.styled.img `
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
//# sourceMappingURL=styles.js.map